import { render, staticRenderFns } from "./RegistrarAmparo.vue?vue&type=template&id=41a74cee&"
import script from "./RegistrarAmparo.vue?vue&type=script&lang=js&"
export * from "./RegistrarAmparo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports